export const prepareInitialFormState = formConfig =>
  formConfig.reduce((acc, input) => {
    acc[input.placeholder] = '';
    return acc;
  }, {});
